<template>
    <span>
        <div :class="'list-post-counter ' + (this.mainclass ? this.mainclass : '')">
            <div v-if="isFavorited" @click.prevent="unFavorite(episode)">
                <span>{{ this.faveCount > 0 ? this.faveCount : "0" }}</span>
                <i class="fa fa-heart"></i>
            </div>
            <div v-else @click.prevent="favorite(episode)">
                <span>{{ this.faveCount > 0 ? this.faveCount : "0" }}</span>
                <i class="fa fa-heart-o" aria-hidden="true"></i>
            </div>
        </div>
    </span>
</template>

<script>
import axios from 'axios';
    export default {
        props: ['episode', 'favorited', 'count', 'loggedin', 'mainclass'],

        data: function() {
            return {
                isFavorited: '',
                faveCount: this.count,
                loggedIn: this.loggedin
            }

        },
        mounted() {
            this.isFavorited = this.isFavorite ? true : false;
        },
        computed: {
            isFavorite() {
                return this.favorited;
            },
        },
        methods: {
            favorite(episode) {
                if (this.loggedIn === 1) {
                    axios.post('/favorite/' + episode)
                        .then(
                            response => this.isFavorited = true,
                            this.faveCount = this.faveCount + 1
                        )
                        .catch(response => console.log(response.data));
                } else {
                    swal({
                        title: "Sorry",
                        text: "You must be signed in to add episodes to your favourites",
                        type: "warning",
                        timer: 2000,
                        showConfirmButton: false
                    });
                    //$('.reg-btn .modal-trigger').click();
                }
            },
            unFavorite(episode) {
                if (this.loggedIn === 1) {
                axios.post('/unfavorite/'+episode)
                    .then(
                        response => this.isFavorited = false,
                        this.faveCount = this.faveCount-1
                    )
                    .catch(response => console.log(response.data));
                } else {
                    swal({
                        title: "Sorry",
                        text: "You must be signed in to add episodes to your favourites",
                        type: "warning",
                        timer: 2000,
                        showConfirmButton: false
                    });
                }
            }
        }
    }
</script>
